import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function SmallScreenOffCanvasFilters() {
    this.defaultAttrs({
        close: '[data-close]',
        form: '[data-small-screen-off-canvas-filters-form]',
        item: '[data-small-screen-off-canvas-filters-item]',

        button: '[data-small-screen-off-filters-button]',

        input: '[data-small-screen-off-canvas-filters-input]',
        section: '[data-small-screen-off-canvas-filters-section]',
        back: '[data-small-screen-off-canvas-filters-section-back]',
    });

    this.after('initialize', function() {
        this.on('click', {
            close: this.deactivate,
            item: this.selectItem,
            button: this.activateSection,
            back: this.deactivateSection,
        });

        this.on(document, 'uiActivateSmallScreenOffCanvasFilters', this.activate);
    });

    this.activate = function(e, data) {
        if (data.name === this.$node.attr('data-small-screen-off-canvas-filters-name')) {
            this.$node.attr('data-active', '');
        }
    };

    this.deactivate = function() {
        this.$node.removeAttr('data-active');
        this.select('section').attr('data-small-screen-off-canvas-filters-section-active', 'false');
    };

    this.activateSection = function(e, data) {
        const name = $(data.el).attr('data-small-screen-off-filters-button-name');
        const $el = $(`[data-small-screen-off-canvas-filters-section-name="${name}"]`);
        $el.attr('data-small-screen-off-canvas-filters-section-active', 'true');
    };

    this.deactivateSection = function(e, data) {
        const $el = $(data.el).parents('[data-small-screen-off-canvas-filters-section]');
        $el.attr('data-small-screen-off-canvas-filters-section-active', 'false');
    };

    this.selectItem = function(e, data) {
        e.preventDefault();
        const value = $(data.el).attr('data-value');

        const $section = $(data.el).parents(this.attr.section);

        if (value && $section.find(`[value=${value}]`).length) {
            $section.find(`[value=${value}]`).remove();
            this.select('input').remove();
        } else {
            const $input = $section.find(this.attr.input);
            $input.val(value);
        }
        this.select('form').submit();
    };
}

export default defineComponent(SmallScreenOffCanvasFilters);



// WEBPACK FOOTER //
// ./src/js/component_ui/small-screen-off-canvas-filters.js